import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Route, Switch} from 'react-router-dom'

// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import GlobalHeader from '../GlobalHeader'
import LoginForm from './LoginForm'
import ResetPassword from './ResetPassword'
import ActivateUser from './ActivateUser'

import './login.css'
import FlashMessage from '../FlashMessage'

class Login extends Component {
  render () {
    return (
      <>
        <GlobalHeader/>
        <FlashMessage/>
        <div className='container-fluid login'>

          <Switch>
            <Route path='/login/' component={LoginForm}/>
            <Route path='/activate-user/' component={ActivateUser}/>
            <Route path='/reset-password/' component={ResetPassword}/>
            <Route path='/' component={LoginForm} />
          </Switch>
        </div>
      </>
    )
  }
}

function mapStateToProps ({spinner}) {
  return {spinner}
}

export default connect(mapStateToProps)(Login)
